import React from "react";
import PropTypes from "prop-types";
import DataTable from "components/DataTable";
import { H3 } from "components/Text";
import { FormattedMessage } from "react-intl";
import { Header } from "components/DisplayBox";

/**
 * RoleInterviewAIQuestionsForm
 *
 * @param {Array}    questions
 */
const RoleInterviewAIQuestionsForm = ({ questions, ...props }) => {
  const questionsWithIds = questions.map((question, index) => ({ id: index, ...question }));

  return (
    <>
      <Header noUnderline {...props}>
        <H3>
          <FormattedMessage id="Missions.Roles.RoleVetting.Interviews.AIGeneratedQuestions.Header" />
        </H3>
      </Header>
      <DataTable
        data={questionsWithIds}
        columns={COLUMNS}
        {...props}
      />
    </>
  );
};

const COLUMNS = [
  {
    label: "Title",
    cell: (row) => row.title,
    width: "30%",
  },
  {
    label: "Description",
    cell: (row) => row.description,
    width: "70%",
  },
];

RoleInterviewAIQuestionsForm.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
};

export default RoleInterviewAIQuestionsForm;
